import { useMutation, useQueryClient } from "@tanstack/react-query";
import { apiClient } from "@copro/api";
import { keys as remindersKeys } from "./keys";
import { keys as calendarKeys } from "../../calendar/api/keys";
import { keys as topicsKeys } from "../../topics/api/keys";
import { useSpace } from "../../../hooks/useSpace";
import { enqueueSnackbar } from "../../../components/GlobalSnackbar/snackbarStore";

async function deleteReminder(reminderId: string) {
  const { error } = await apiClient
    .from('reminders')
    .delete()
    .eq('id', reminderId);

  if (error) {
    throw error;
  }
}

export default function useDeleteReminder() {
  const queryClient = useQueryClient();
  const { currentSpace } = useSpace();

  return useMutation({
    mutationFn: (reminderId: string) => deleteReminder(reminderId),
    onSuccess: () => {
      enqueueSnackbar('Rappel supprimé.', 'success');
      queryClient.invalidateQueries({ queryKey: remindersKeys.lists() });
      queryClient.invalidateQueries({ queryKey: remindersKeys.upcomingAll() });
      queryClient.invalidateQueries({ queryKey: calendarKeys.list() });
      if (currentSpace?.id) {
        queryClient.invalidateQueries({ queryKey: topicsKeys.pendingSubTopics(currentSpace.id) });
      }
    },
  });
}
